import React from 'react';
import { Row, cls } from '../../packages/components';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import PropTypes from 'prop-types';
import { playFullMedia } from '../../actions/playmedia';
import store from './../../store';
import LayersControl from '../../utils/LayersControl';
import './styles/AAFModalSuspendedAccount.scss';

const MAIN_CLASSNAME = 'aaf_app_modal-suspended-account';

const stop = () => {
    if (LayersControl.isPlayerVisible()) {
      LayersControl.hidePlayer(true);
    }
    const nullPlayer = {
      ispip: false,
      islive: false,
      ispreview: false,
      playerstate: 'STOPPING',
      event: null
    };
    store.dispatch(playFullMedia(nullPlayer));
  };

const BodyContent = ({ props }) => {
    stop();
    const {title, description, content, phoneNumber, footer1, footer2} = props
    return (
        <div className={MAIN_CLASSNAME}>
            <Row className='suspended_modal_title' maxlength="50">
                <span>{title}</span>
            </Row>
            <Row className='suspended_modal_description'>
                <span>{description}</span>
            </Row>
            <Row className='suspended_modal_title_callCenter'>
                <span>{content}</span>
            </Row>
            <Row className='suspended_modal_number_callCenter'>
                <span>{phoneNumber}</span>
            </Row>
            <Row className='suspended_modal_footer_callCenter'>
                <span>{footer1}</span>
                <span>{footer2}</span>
            </Row>
        </div>
    );
};

const AAFModalSuspendedAccount = (props = {}) => {
    const p = {
        alwaysEnabled: true,
        buttonsAlign: 'vertical',
        aafNewStyle: true,
        className: 'aaf-modal',
        showLogo: true,
        callbackWhenBack : ()=> {}
    };

    return (
        <ModalWrapper {...p}>
            <BodyContent props={props} />
        </ModalWrapper>
    );
};

AAFModalSuspendedAccount.propTypes = {
    content: PropTypes.string,
    title: PropTypes.string,
    footer: PropTypes.string,
    className: PropTypes.string,
};

export default withOnClose(AAFModalSuspendedAccount);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalSuspendedAccount.jsx